import { adminHttpClient } from '../../../../commons/adminHttpClient'

export interface FamilyMember {
  id: string
  firstName: string
  lastName: string
  relationship: number
}

const getFamilyMembersApi = (): Promise<any> => {
  return adminHttpClient.get('/EEDashboard/GetReimbursed/FamilyMember/FamilyMembers')
}

export default getFamilyMembersApi
